var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40216 16.1243C1.40216 7.56385 8.34175 0.624268 16.9022 0.624268C25.4626 0.624268 32.4022 7.56385 32.4022 16.1243C32.4022 24.6847 25.4626 31.6243 16.9022 31.6243C8.34175 31.6243 1.40216 24.6847 1.40216 16.1243Z",
    fill: "#50EF90",
    fillOpacity: 0.1,
    stroke: "#50EF90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6739 9.78027C12.1115 9.78027 11.5721 10.0002 11.1745 10.3917C10.7768 10.7833 10.5534 11.3143 10.5534 11.868L10.5534 19.7177C10.5534 20.2714 10.7768 20.8024 11.1745 21.194C11.5721 21.5855 12.1115 21.8054 12.6739 21.8054L17.339 21.8054L17.339 18.5486C17.339 17.9949 17.5624 17.4639 17.96 17.0724C18.3577 16.6809 18.8971 16.4609 19.4594 16.4609L22.7674 16.4609L22.7674 11.868C22.7674 11.3143 22.544 10.7833 22.1463 10.3917C21.7487 10.0002 21.2093 9.78027 20.6469 9.78027L12.6739 9.78027ZM22.5798 17.296L19.4594 17.296C19.122 17.296 18.7984 17.428 18.5598 17.6629C18.3212 17.8978 18.1871 18.2164 18.1871 18.5486L18.1871 21.6207C18.4206 21.5169 18.6331 21.3722 18.8141 21.1938L22.1462 17.9136C22.3274 17.7352 22.4743 17.526 22.5798 17.296Z",
    fill: "#50EF90"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartHistory);
export default __webpack_public_path__ + "static/media/chart_history.3fd7792aed71314a9f57382f206bc6bb.svg";
export { ForwardRef as ReactComponent };